import React, { useState, useEffect } from "react";
import Loading from "../../../Loading/Loading";
import Listing from "../../../Listing/Listing";
import { toQueryString } from "../../../../util/utilFunctions";
import axios from "axios";
import styles from "./DashListings.module.css";
import PropertyFilter from "../../../PropertyFilter/PropertyFilter";
import DashListingCard from "../DashListingCard/DashListingCard";
import { toast } from "react-toastify";

function DashListings({
  passedListings = [],
  accessToken,
  listingType,
  handleRestore,
  role,
}) {
  const [activeListings, setActiveListings] = useState([]);
  const [deletedListings, setDeletedListings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const active = passedListings.filter((listing) => !listing.deleted_at);
    const deleted = passedListings.filter((listing) => listing.deleted_at);
    setActiveListings(active);
    setDeletedListings(deleted);
  }, [passedListings]);

  // const handleApplyFilters = (filterData) => {
  //   fetchListingsData(filterData);
  // };

  // const fetchListingsData = async (filterData) => {
  //   setIsLoading(true);
  //   try {
  //     const queryString = toQueryString({
  //       ...filterData,
  //       listingType: listingType,
  //     });

  //     var url = `${
  //       import.meta.env.VITE_BACKEND_URL
  //     }/dash/landlord-listings?${queryString}`;
  //     if (role == "pro") {
  //       url = `${
  //         import.meta.env.VITE_BACKEND_URL
  //       }/dash/pro-listings?${queryString}`;
  //     }
  //     const response = await axios.get(url, {
  //       headers: {
  //         Authorization: accessToken,
  //       },
  //     });

  //     // console.log("response: ", response);

  //     if (response.status === 200) {
  //       if (response.data.success) {
  //         setListings(response.data.listings || []);
  //       } else {
  //         const errorMsg = response.data.message || "Error fetching listings.";
  //         toast.error(errorMsg);
  //       }
  //     } else {
  //       const errorMsg = response.data.message || "Error fetching listings.";
  //       toast.error(errorMsg);
  //     }
  //   } catch (error) {
  //     toast.error("Error fetching listings. Please try again!");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleRestore = async (listingId) => {
  //   try {
  //     setIsLoading(true);

  //     await axios.post(
  //       `${import.meta.env.VITE_BACKEND_URL}/listings/restore/${listingId}`,
  //       {},
  //       {
  //         headers: { Authorization: accessToken },
  //       }
  //     );

  //     // Refresh listings after restore
  //     fetchListingsData({});
  //   } catch (error) {
  //     toast.error("Error restoring listing:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }; 

  return (
    <div>
      {/* TODO: Feature for the future.*/}
      {/* <PropertyFilter onApplyFilters={handleApplyFilters} /> */}
      {isLoading ? (
        <div className="buy-and-sell-loading">
          <Loading />
        </div>
      ) : (
        <div>
          <div className={styles.listingContainer}>
            {/* <h2 className={styles.sectionTitle}>Active Listings</h2> */}
            <h1 style={{ color: "#1e40af", marginBottom: "3rem" }}>Active Listings</h1>
            {activeListings && activeListings.length ? (
              <div className={styles.propertyList}>
                {activeListings.map((listing) => (
                  <DashListingCard key={listing.id} listing={listing} />
                ))}
              </div>
            ) : (
              <p>No active listings available.</p>
            )}
          </div>
          <div className={styles.listingContainer}>
            <h1 style={{ color: "#1e40af", marginBottom: "3rem" }}>Deleted Listings</h1>
            {deletedListings && deletedListings.length ? (
              <div className={styles.propertyList}>
                {deletedListings.map((listing) => (
                  <div key={listing.id} className={styles.deletedListing}>
                    <DashListingCard listing={listing} />
                    <p className={styles.deletionReason}>
                      Reason: {listing.listing_status || "No reason provided"}
                    </p>
                    <button
                      onClick={() => handleRestore(listing.id)}
                      className={styles.restoreButton}
                    >
                      Restore Listing
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              
              <p>No deleted listings available.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default DashListings;
